import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Vuetify
import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import '@mdi/font/css/materialdesignicons.css';

// i18n
import { createI18n } from 'vue-i18n';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';

// Config State
import { loadConfig } from './configState.js';

// --- MAIN STARTUP FUNCTION ---
async function initApp() {

    // 1. SCHRITT: Technische Config vom Server laden (DB + .env)
    // Das lädt jetzt auch das aktive Theme (z.B. 'royal') in den State
    await loadConfig();

    // (Schritt 2 & 3 mit dem alten fetch 'branding.json' ERSATZLOS GESTRICHEN)

    // 4. SCHRITT: Vuetify initialisieren
    // Wir setzen hier nur Basis-Defaults. Die echten Farben kommen
    // gleich dynamisch über useBranding.js (CSS-Variablen), sobald App.vue mountet.
    const vuetify = createVuetify({
        components,
        directives,
        theme: {
            defaultTheme: 'dark', // Wir starten standardmäßig dunkel
            themes: {
                dark: {
                    dark: true,
                    colors: {
                        primary: '#D500F9', // Velvet Purple als Start-Fallback
                        secondary: '#03DAC6',
                        background: '#121212',
                        surface: '#1E1E1E'
                    }
                }
            }
        }
    });

    // 5. SCHRITT: i18n initialisieren
    const i18n = createI18n({
        legacy: false,
        locale: 'de',
        fallbackLocale: 'en',
        messages: { de, en, es }
    });

    // 6. SCHRITT: App erstellen und mounten
    const app = createApp(App);

    app.use(router);
    app.use(vuetify);
    app.use(i18n);

    app.mount('#app');
    console.log("🚀 App gestartet.");
}

// Starten
initApp();